<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Fornecedor</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroFornecedor" ref="formCadastroFornecedor" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-select v-model="item.tipo" label="Tipo" :items="tipos" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="80" maxlength="80" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.cpfCnpj" :label="lblCpfCnpj" :rules="fieldRules" v-mask="mskCpfCnpj" counter="18" maxlength="18" @blur="item.cpfCnpj = (item.cpfCnpj || '').toLocaleUpperCase()" @change="VerificarExistente()" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.identidadeInscricaoEstadual" :label="lblIdentidadeInscricaoEstadual" :counter="15" maxlength="15" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.cep" label="CEP" v-mask="mskCep" @change="ObterEndereco(item.cep)" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.logradouro" label="Logradouro" :counter="80" maxlength="80" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="item.bairro" label="Bairro" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="item.cidade" label="Cidade" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="item.estado" label="Estado" :items="estados" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="item.pais" label="País" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataNascimentoFundacao" :label="lblNascimentoFundacao" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataNascimentoFundacao" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.telefone" label="Telefone" v-mask="mskTelefone" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.celular" label="Celular" v-mask="mskTelefone" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="item.email" label="E-mail" :counter="60" maxlength="60" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="item.situacao" label="Situação" :items="situacoes" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-textarea v-model="item.observacao" label="Observação" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import { MskCpf, MskCnpjAlfa, MskTelefone, MskCep } from '@/core/domain/shared/Global';
import FornecedorService from '@/core/services/financeiro/FornecedorService';
import Fornecedor from '@/core/domain/financeiro/Fornecedor';
import {EstadoEnumService, TipoPessoaEnumService, EnderecoService } from '@/core/services/geral';
import { SituacaoEnumService } from '@/core/services/geral';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroFornecedor' in this.$refs)
                this.$refs.formCadastroFornecedor.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        },
        'item.tipo': {
            handler: function (val) {
                if (val === 0){
                    this.mskCpfCnpj = MskCpf;
                    this.lblCpfCnpj = 'CPF';
                    this.lblIdentidadeInscricaoEstadual = 'Identidade';
                    this.lblNascimentoFundacao = 'Nascimento';
                }
                else {
                    this.mskCpfCnpj = MskCnpjAlfa;
                    this.lblCpfCnpj = 'CNPJ';
                    this.lblIdentidadeInscricaoEstadual = 'Inscrição Estadual';
                    this.lblNascimentoFundacao = 'Fundação';
                }

            },
            deep: true
        },
    },
    data: () => ({
        service: new FornecedorService(),
        mskCpfCnpj: MskCpf,
        mskTelefone: MskTelefone,
        mskCep: MskCep,
        lblCpfCnpj: 'CPF',
        lblIdentidadeInscricaoEstadual: 'Identidade',
        lblNascimentoFundacao: 'Nascimento',
        valid: true,
        dialog: false,
        isLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        tipos: [],
        estados: [],
        situacoes: [],
        salvando: false
    }),
    methods: {
        VerificarExistente(){
            this.service.VerificarExistente(this.item.cpfCnpj).then(
                res => {
                    let resposta = res.data;
                    if(resposta){
                        this.$swal('Aviso', "Já existe um Doador com esse CPF/CNPJ cadastrado.", 'warning')
                    }
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
        },
        save() {

            if (this.$refs.formCadastroFornecedor.validate()) {

                this.salvando = true;

                let modelo = new Fornecedor(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        this.$swal('Aviso', err.response.data, err.response.status == 400 ? 'warning' : 'error');
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }

        },
        close() {
            this.dialog = false;
        },
        ObterEndereco(cep){
            let enderecoService = new EnderecoService();
            enderecoService.ObterPorCep(cep)
            .then(
                res => {
                    let endereco = res.data;
                    if (endereco) {
                        this.item.logradouro = endereco.logradouro;
                        this.item.bairro = endereco.bairro;
                        this.item.cidade = endereco.municipio;
                        this.item.estado = endereco.estado;
                        this.item.pais = endereco.pais;
                    }
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {
        let tipoEnumService = new TipoPessoaEnumService();
        tipoEnumService.Listar()
            .then(
                res => {
                    this.tipos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        let estadoEnumService = new EstadoEnumService();
        estadoEnumService.Listar()
            .then(
                res => {
                    this.estados = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );

        let situacaoEnumService = new SituacaoEnumService();
        situacaoEnumService.Listar()
            .then(
                res => {
                    this.situacoes = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
    }
}
</script>
